module.exports = __webpack_public_path__ + "img/naked-insurance-banner-main.1e71bd30.jpg";